import React, { Component } from 'react';
import { API_PREFERENCES, SUPER_ADMIN, VPN_SETTING_PROXY, API_VPN_RESTART_ALL } from '../../config';

import Loading from '../../common/loading';
import { Page, PageHeader, Card, SearchInput, DataList, TextButton, Badge, Country, matchSearch } from '../../common/ui';
import ModalVpnSetting from '../../common/modal/modalVpnSetting';
import { returnNationality } from '../../common/actions/returnNationality';
import { isEmpty, withNavigate } from '../../utility';
import axiosInstance from '../../axiosInstance';
import Modal from '../../common/modal';

class vpnSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            loadingForRole: true,
            hasClickNew: false,
            hasClickEdit: false,
            modal: false,
            type: "",

            modalMachine: false,
            title: "",
            contentModal: "",

            // contiene la lista dei country con fake VPN
            getVpnSettingList: {},
            updateCountry: {},
            deleteCountry: "",

            // testo di ricerca nella lista
            search: ""
        }
    }

    /**
     * Il mount e l'update sono uguali, poiche se navigo tra i link di react router, dopo aver
     * caricato questa pagina, esegue solo il mount, mentre se refresho la pagina carica l'update.
     * 
     * (Esempio: se vado una prima volta sulla pagina utenti, dopo il mount carica update.
     * Se dopo il caricamento, senza refreshare, navigo e vado ad altre parti, esempio player, e poi ritorno,
     * react carica solo il mount e nemmeno una volta update.)
     */
    componentDidMount() {
        // se l'utente non ha nessun permesso per visualizzare vpn setting, viene rispedito alla home
        if (!isEmpty(this.props.role.preferences)) {
            if (this.props.user.user.role !== SUPER_ADMIN) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare Vpn Setting!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getVpnSettingList();
                }
            }
        }
    }

    componentDidUpdate() {
        // se l'utente non ha nessun permesso per visualizzare vpn setting, viene rispedito alla home
        if (!isEmpty(this.props.role.preferences)) {
            if (this.props.user.user.role !== SUPER_ADMIN) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare Vpn Setting!')

            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getVpnSettingList();
                }
            }
        }

        if (!localStorage.token) {
            this.props.handleNavigation(this.props.navigate, '/');
        }
    }

    /**
     * Chiama il BE e ritorna la lista dei paesi con fake VPN
     * 
     */
    getVpnSettingList = async () => {
        this.setState({ isLoading: true });
        try {
            let response = await axiosInstance.get(`${API_PREFERENCES}/${VPN_SETTING_PROXY}`);
            this.setState({
                getVpnSettingList: response.data,
                isLoading: false
            });

        } catch (result) {
            const { errorNotify } = this.props;
            this.setState({ isLoading: false });

            if (result && result.response && result.response.status) {
                switch (result.response) {
                    default: errorNotify(`Error ${result.response.status} su ${API_PREFERENCES} - GET`); break;
                }
            }
        }
    }

    /**
     * Riavvia tutte le VPN Machine
     */
    restartAllVpnMachine = () => {
        let that = this;
        let thatProps = this.props;
        that.setState({ isLoading: true });

        axiosInstance.put(`${API_VPN_RESTART_ALL}`)
            .then(function () {
                thatProps.successNotify('VPN Machine riavviate!');
                that.toggleModal();
                that.setState({ isLoading: false });
            })

            .catch(function (result) {
                that.setState({ isLoading: false });
                switch (result.response.status) {
                    case 404: thatProps.errorNotify('VPN machine errore riavvio!'); break;
                    default: thatProps.errorNotify(`Error ${result.response.status} su ${API_VPN_RESTART_ALL} - PUT`); break;
                }
            });
    }

    /**
     * Aggiungi alla lista una fake VPN
     * 
     */
    hasClickNew = (type) => {
        this.setState({
            hasClickNew: true,
            type: type
        });


        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 1000);
    }

    /**
     * Rimuove il paese dalla lista fake VPN
     * 
     */
    hasClickEdit = (country, type) => {
        this.setState({
            hasClickEdit: true,
            type: type,
            deleteCountry: country.toString(),

            updateCountry: {
                [country]: {
                    isEnabled: false
                }
            }
        });

        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 1000);
    }

    /**
     * Invio la modifica della lista dei vpn setting
     */
    sendEditVpnSettingList = (id, data) => {
        if (this.state.type === "remove") {
            this.props.deleteKeyFromList(id, this.state.deleteCountry);

        } else {
            this.props.sendEditPreferences(id, data);
        }

        this.toggleModal();

        setTimeout(() => {
            this.getVpnSettingList();
        }, 1500);
    }

    setInfoModal = (titleModal, contentModal) => {
        this.setState({
            titleModal: titleModal,
            contentModal: contentModal
        });

        setTimeout(() => {
            this.setState(prevState => ({ modalMachine: !prevState.modalMachine }));
        }, 100);
    }

    /**
     * Usato solo per chiudere la modale, poiche resetta tutto lo state
     */
    toggleModal = () => {
        if (this.state.type !== "") {
            this.setState(prevState => ({ modal: !prevState.modal }));

        } else {
            this.setState(prevState => ({ modalMachine: !prevState.modalMachine }));
        }

        this.setState({
            hasClickNew: false,
            hasClickEdit: false,
            updateCountry: {},
            deleteCountry: "",
            type: "",
            titleModal: "",
            contentModal: ""
        });
    }

    render() {
        const { getVpnSettingList, search } = this.state;
        const isSuperAdmin = this.props.user.user.role === SUPER_ADMIN;

        const countries = Object.keys(getVpnSettingList)
            .filter(code => matchSearch(search, code, returnNationality(code)))
            .map(code => ({ code, ...getVpnSettingList[code] }));

        return (
            <Page>
                {(this.state.isLoading || this.state.loadingForRole) && <Loading />}

                <PageHeader
                    title="VPN Setting"
                    subtitle={`${Object.keys(getVpnSettingList).length} paesi con fake VPN`}
                    actions={
                        <>
                            <button type="button" className="btn btn-sm btn-outline-warning" onClick={() => { this.setInfoModal("Riavvia Machine", "Sei sicuro di voler riavviare tutte le VPN Maschines ?") }}>
                                <i className="fas fa-sync-alt" aria-hidden="true" /> Riavvia machines
                            </button>
                            <button type="button" className="btn btn-sm btn-success" onClick={() => { this.hasClickNew("new") }}>
                                <i className="fas fa-plus" aria-hidden="true" /> Aggiungi VPN
                            </button>
                        </>
                    }
                />

                <Card>
                    <div className="uiToolbar">
                        <SearchInput value={search} onChange={value => this.setState({ search: value })} placeholder="Cerca per paese o sigla" />
                        {search && <span className="uiCount">{countries.length} risultati</span>}
                    </div>

                    <DataList
                        columns={[
                            { key: 'code', label: 'Paese', width: 'minmax(0, 2fr)', render: el => <Country code={el.code} /> },
                            { key: 'sigla', label: 'Sigla', width: '90px', render: el => <span className="uiMono">{el.code}</span> },
                            { key: 'isEnabled', label: 'Stato', width: '130px', render: el => el.isEnabled ? <Badge variant="success">Abilitato</Badge> : <Badge variant="danger">Disabilitato</Badge> },
                        ]}
                        rows={countries}
                        rowKey={el => el.code}
                        empty={search ? 'Nessun paese trovato' : 'Nessun paese configurato'}
                        actionsWidth="110px"
                        actions={
                            isSuperAdmin ?
                                el => <TextButton icon="far fa-trash-alt" variant="danger" onClick={() => { this.hasClickEdit(el.code, "remove") }}>Rimuovi</TextButton>
                                : undefined
                        }
                    />
                </Card>

                {
                    (this.state.hasClickNew || this.state.hasClickEdit) &&
                    <ModalVpnSetting
                        titleModal={this.state.type === "remove" ? "Rimuovi Nazione" : "Aggiungi Nazione"}

                        sendEditVpnSettingList={this.sendEditVpnSettingList}
                        updateCountry={this.state.updateCountry}
                        type={this.state.type}

                        toggle={this.toggleModal}

                        stateModal={this.state.modal}
                        errorNotify={this.props.errorNotify}
                    />
                }

                <Modal
                    click={() => { this.restartAllVpnMachine() }}
                    titleModal={this.state.titleModal}
                    contentModal={this.state.contentModal}
                    toggle={this.toggleModal}
                    stateModal={this.state.modalMachine}
                />
            </Page>
        )
    }
}

export default withNavigate(vpnSetting);